import { type FC, type PropsWithChildren, createContext } from 'react';

export type ForwardableDocumentProps = { title: string; type: string; content: string };

type ForwardDocumentCallback = ({
  document,
  agentId,
}: {
  document: ForwardableDocumentProps;
  agentId: string;
}) => any;

export type ForwardDocumentContextType = ForwardDocumentCallback;

/** Stores a document forwarding function of type ForwardDocumentCallback. */
export const ForwardDocumentContext = createContext<ForwardDocumentContextType | undefined>(
  undefined
);

type ForwardDocumentProviderProps = PropsWithChildren & {
  onForwardDocument?: ForwardDocumentCallback;
};

/**
 * Exposes a given forwarding function to downstream components.  The function is
 * given as a prop. The Context & Provider don't actually implement the function, they just
 * store it and provide it for downstream components to consume. It is the responsibility of
 * the app that uses this ForwardDocumentProvider to implement the function itself.  For
 * example, an app may implement a function that takes a given document and uploads it to
 * the internet, saves it to disk, sends it in an email, or starts a new chat with it.
 */
export const ForwardDocumentProvider: FC<ForwardDocumentProviderProps> = ({
  onForwardDocument,
  children,
}) => {
  return <ForwardDocumentContext value={onForwardDocument}>{children}</ForwardDocumentContext>;
};

ForwardDocumentProvider.displayName = 'ForwardDocumentProvider';
